import { ToolPlugin } from '@hose/chat-app';
import { FlowResult, AuditFlow, RelatedApplication, FlowTemplateMatched, FeeTypeMatched, MyConsumptions} from '../../components';

const toolNamePrefix = 'ai-flow.'

// 导出工具插件
export const formTools: ToolPlugin[] = [
  {
    toolName: `combine`, // 单个单据，旧版
    toolComponent: (context) => <FlowResult {...context} />,
    toolCallResult: (result) => {
      console.log('渲染完成:', result);
    }
  },
  {
    toolName: `combine_batch`, // 多个单据，旧版
    toolComponent: (context) => <FlowResult {...context} />,
    toolCallResult: (result) => {
      console.log('渲染完成:', result);
    }
  },
  {
    toolName: `audit_flow`,  //  智能预审，旧版
    toolComponent: (context) => <AuditFlow {...context} />,
    toolCallResult: (result) => {
      console.log('渲染完成:', result);
    }
  },
  {
    toolName: `${toolNamePrefix}combine`, // 单个单据
    toolComponent: (context) => <FlowResult {...context} />,
    toolCallResult: (result) => {
      console.log('渲染完成:', result);
    }
  },
  {
    toolName: `${toolNamePrefix}combineBatch`, // 多个单据
    toolComponent: (context) => <FlowResult {...context} />,
    toolCallResult: (result) => {
      console.log('渲染完成:', result);
    }
  },
  {
    toolName: `${toolNamePrefix}modifyDocumentField`,  
    toolComponent: (context) => <FlowResult {...context} />,
    toolCallResult: (result) => {
      console.log('渲染完成:', result);
    }
  },
  {
    toolName: `${toolNamePrefix}modifyDocumentTemplate`, 
    toolComponent: (context) => <FlowResult {...context} />,
    toolCallResult: (result) => {
      console.log('渲染完成:', result);
    }
  },
  {
    toolName: `${toolNamePrefix}modifyFeeType`, 
    toolComponent: (context) => <FlowResult {...context} />,
    toolCallResult: (result) => {
      console.log('渲染完成:', result);
    }
  },
  {
    toolName: `${toolNamePrefix}auditFlow`,  //  智能预审
    toolComponent: (context) => <AuditFlow {...context} />,
    toolCallResult: (result) => {
      console.log('渲染完成:', result);
    }
  },
  {
    toolName: `${toolNamePrefix}requisitionReason`,  //  确定关联申请
    toolComponent: (context) => <RelatedApplication {...context} />,
    toolCallResult: (result) => {
      console.log('渲染完成:', result);
    }
  },
  {
    toolName: `${toolNamePrefix}feeTypeReason`,  //  确定费用明细
    toolComponent: (context) => <FeeTypeMatched {...context} />,
    toolCallResult: (result) => {
      console.log('渲染完成:', result);
    }
  },
  {
    toolName: `${toolNamePrefix}specificationReason`,  //  确定单据模板
    toolComponent: (context) => <FlowTemplateMatched {...context} />,
    toolCallResult: (result) => {
      console.log('渲染完成:', result);
    }
  },
  {
    toolName: `${toolNamePrefix}consumptionGrouping`,  //  AI 记消费
    toolComponent: (context) => <MyConsumptions {...context} />,
    toolCallResult: (result) => {
      console.log('渲染完成:', result);
    }
  },
]; 